export class Auth {
  public ClientID!: string;
  public Authority!: string;
  public PasswordResetFlowName!: string;
  public Scope!: string;

  constructor() {
    this.ClientID = "";
    this.Authority = "";
    this.PasswordResetFlowName = "";
    this.Scope = "";
  }
}
